var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.499859C5.04 0.499859 4.66666 0.872359 4.66666 1.33319C4.66666 1.79403 5.04 2.16653 5.5 2.16653L7.41416 2.16653L3.29083 5.70069C2.9825 5.96403 2.90916 6.41236 3.11916 6.76236L5.25166 10.3165L0.799998 14.0257C0.447498 14.3207 0.397498 14.8449 0.693331 15.2007C0.987498 15.5532 1.51333 15.6015 1.86666 15.3074L6.86666 11.1407C7.1825 10.8765 7.26 10.4224 7.0475 10.0707L4.91 6.50819L8.83333 3.14486L8.83333 5.49986C8.83333 5.96069 9.20666 6.33319 9.66666 6.33319C10.1267 6.33319 10.5 5.96069 10.5 5.49986L10.5 1.33319C10.5 1.22986 10.4775 1.12736 10.4383 1.02986C10.4225 0.989025 10.3958 0.957358 10.375 0.919859C10.3492 0.876524 10.3333 0.829858 10.2992 0.791525C10.2925 0.783192 10.2825 0.779858 10.275 0.772358C10.2333 0.726525 10.1825 0.694858 10.1317 0.659858C10.0917 0.632358 10.0567 0.599859 10.0133 0.580692C9.96916 0.559859 9.92 0.553191 9.8725 0.541524C9.81416 0.525692 9.7575 0.508192 9.6975 0.506525C9.68666 0.505691 9.6775 0.499858 9.66666 0.499858L5.5 0.499859Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWhiteArrow);
export default __webpack_public_path__ + "static/media/up-white-arrow.9ff88c2fc3c9e0e86db31c65e0baa9de.svg";
export { ForwardRef as ReactComponent };